import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ProfessionsIcon({ className }: IconProps) {
  return (
    <svg
      width="94"
      height="91"
      viewBox="0 0 94 91"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2034)">
        <path
          d="M70.7668 69.6509C69.1815 57.4254 61.437 47.1811 50.7817 42.0459C46.3897 45.0436 41.088 46.7901 35.3966 46.7901C29.7051 46.7901 24.4035 45.0436 20.0115 42.0459C9.35622 47.1811 1.61168 57.4254 0.0263887 69.6509C-0.285472 72.1272 1.63767 74.3169 4.13255 74.3169H66.6606C69.1555 74.3169 71.0787 72.1272 70.7668 69.6509Z"
          fill="#00416B"
        />
        <path
          d="M54.6022 19.2635C54.6022 29.8989 46.0001 38.5271 35.3968 38.5271C24.7936 38.5271 16.1914 29.8989 16.1914 19.2635C16.1914 8.62819 24.7936 0 35.3968 0C46.0001 0 54.6022 8.62819 54.6022 19.2635Z"
          fill="#00416B"
        />
        <path
          d="M36.7479 58.729C36.462 57.7384 36.6699 56.6697 37.3196 55.8616L46.5195 44.3921C43.115 45.904 39.3727 46.7642 35.3965 46.7642C31.4202 46.7642 27.6779 45.904 24.2734 44.3921L33.4733 55.8355C34.097 56.6175 34.3309 57.6863 34.0451 58.6508L28.3536 79.1655C28.1197 80.0257 28.2497 80.9381 28.7434 81.694L34.227 90.3222C34.7727 91.1563 35.9942 91.1824 36.54 90.3222L42.2574 81.694C42.7772 80.912 42.9071 79.9475 42.6472 79.0612L36.6959 58.6508L36.7479 58.729Z"
          fill="#00C4B3"
        />
        <path
          d="M66.2187 42.2026H74.301C78.4592 42.2026 81.8117 45.5653 81.8117 49.736V55.184H77.4716V49.736C77.4716 47.9634 76.0423 46.5558 74.301 46.5558H66.2187C64.4514 46.5558 63.0481 47.9895 63.0481 49.736V55.184H58.708V49.736C58.708 45.5653 62.0605 42.2026 66.2187 42.2026Z"
          fill="#00C4B3"
        />
        <path
          d="M88.5946 86.5946H51.899C49.5081 86.5946 47.585 84.6656 47.585 82.2674V56.3047C47.585 53.9065 49.5081 51.9775 51.899 51.9775H88.5946C90.9856 51.9775 92.9087 53.9065 92.9087 56.3047V82.2674C92.9087 84.6656 90.9856 86.5946 88.5946 86.5946Z"
          fill="#EAEDF8"
        />
        <path
          d="M87.5292 82.8934H52.9906C52.0291 82.8934 51.2754 82.1114 51.2754 81.1729V57.3737C51.2754 56.4093 52.055 55.6533 52.9906 55.6533H87.5292C88.4908 55.6533 89.2444 56.4353 89.2444 57.3737V81.1729C89.2444 82.1374 88.4648 82.8934 87.5292 82.8934ZM52.9906 56.9306C52.7567 56.9306 52.5488 57.1131 52.5488 57.3737V81.1729C52.5488 81.4075 52.7307 81.6161 52.9906 81.6161H87.5292C87.7631 81.6161 87.971 81.4336 87.971 81.1729V57.3737C87.971 57.1391 87.7891 56.9306 87.5292 56.9306H52.9906Z"
          fill="#00C4B3"
        />
        <path
          d="M66.946 72.7271L51.327 68.6085C48.4943 67.8525 46.4932 65.2719 46.4932 62.3263V56.2788C46.4932 53.8806 48.4163 51.9517 50.8072 51.9517H89.6599C92.0508 51.9517 93.974 53.8806 93.974 56.2788V62.3263C93.974 65.2719 91.9988 67.8525 89.1401 68.6085L73.5211 72.7271C71.3641 73.3006 69.0771 73.3006 66.92 72.7271"
          fill="#00C4B3"
        />
        <path
          d="M70.247 69.9121C69.4154 69.9121 68.5838 69.8078 67.7781 69.5993L52.1591 65.4807C50.7297 65.1157 49.7422 63.8124 49.7422 62.3526V56.3051C49.7422 55.7055 50.236 55.2363 50.8337 55.2363H89.6863C90.2841 55.2363 90.7779 55.7316 90.7779 56.3051V62.3526C90.7779 63.8124 89.7903 65.1157 88.3609 65.4807L72.7419 69.5993C71.9363 69.8078 71.1046 69.9121 70.273 69.9121M51.0676 56.5136V62.3266C51.0676 63.2128 51.6653 63.9948 52.5229 64.2034L68.142 68.322C69.5453 68.6869 71.0267 68.6869 72.4301 68.322L88.0491 64.2034C88.9067 63.9688 89.5044 63.2128 89.5044 62.3266V56.5136H51.0936H51.0676Z"
          fill="#EAEDF8"
        />
        <path
          d="M73.4951 68.8433C73.4951 70.642 72.0398 72.1017 70.2466 72.1017C68.4534 72.1017 66.998 70.642 66.998 68.8433C66.998 67.0447 68.4534 65.585 70.2466 65.585C72.0398 65.585 73.4951 67.0447 73.4951 68.8433Z"
          fill="#EAEDF8"
        />
        <path
          d="M72.1961 68.8432C72.1961 69.912 71.3385 70.7982 70.247 70.7982C69.1555 70.7982 68.2979 69.938 68.2979 68.8432C68.2979 67.7484 69.1555 66.8882 70.247 66.8882C71.3385 66.8882 72.1961 67.7484 72.1961 68.8432Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2034">
          <rect width="94" height="91" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
